export default __webpack_public_path__ + "static/media/yever.f08446b1.png";